module.exports = __webpack_public_path__ + "img/android-chrome-192x192.6ce5b516.png";